import engineGroup from '~/assets/icons/engine_2.svg';
import bonnetGroup from '~/assets/icons/tuning/groups/bonnet.svg';
import bootGroup from '~/assets/icons/tuning/groups/boot.svg';
import chassisGroup from '~/assets/icons/tuning/groups/chassis.svg';
import doorsGroup from '~/assets/icons/tuning/groups/doors.svg';
import exhaustGroup from '~/assets/icons/tuning/groups/exhaust.svg';
import fendersGroup from '~/assets/icons/tuning/groups/fenders.svg';
import frontBumperGroup from '~/assets/icons/tuning/groups/front_bumper.svg';
import interiorGroup from '~/assets/icons/tuning/groups/interior.svg';
import lightsGroup from '~/assets/icons/tuning/groups/lights.svg';
import rearBumperGroup from '~/assets/icons/tuning/groups/rear_bumper.svg';
import roofGroup from '~/assets/icons/tuning/groups/roof.svg';
import skirtsGroup from '~/assets/icons/tuning/groups/skirts.svg';
import antennaIcon from '~/assets/icons/tuning/subcategories/antenna.svg';
import bonnetIcon from '~/assets/icons/tuning/subcategories/bonnet.svg';
import bootIcon from '~/assets/icons/tuning/subcategories/boot.svg';
import bootLightsIcon from '~/assets/icons/tuning/subcategories/boot_lights.svg';
import bootSpoilerIcon from '~/assets/icons/tuning/subcategories/boot_spoiler.svg';
import chassisTrimIcon from '~/assets/icons/tuning/subcategories/chassis_trim.svg';
import diffuserIcon from '~/assets/icons/tuning/subcategories/diffuser.svg';
import doorAttachIcon from '~/assets/icons/tuning/subcategories/door_attach.svg';
import doorHandlesIcon from '~/assets/icons/tuning/subcategories/door_handles.svg';
import doorMoldingsIcon from '~/assets/icons/tuning/subcategories/door_moldings.svg';
import exhaustIcon from '~/assets/icons/tuning/subcategories/exhaust.svg';
import frontBumperIcon from '~/assets/icons/tuning/subcategories/front_bumper.svg';
import frontFenderIcon from '~/assets/icons/tuning/subcategories/front_fender.svg';
import frontLightsIcon from '~/assets/icons/tuning/subcategories/front_lights.svg';
import grilleIcon from '~/assets/icons/tuning/subcategories/grille.svg';
import interiorIcon from '~/assets/icons/tuning/subcategories/interior.svg';
import mirrorsIcon from '~/assets/icons/tuning/subcategories/mirrors.svg';
import miscIcon from '~/assets/icons/tuning/subcategories/misc.svg';
import rearBumperIcon from '~/assets/icons/tuning/subcategories/rear_bumper.svg';
import rearFenderIcon from '~/assets/icons/tuning/subcategories/rear_fender.svg';
import rearLightsIcon from '~/assets/icons/tuning/subcategories/rear_lights.svg';
import roofIcon from '~/assets/icons/tuning/subcategories/roof.svg';
import roofMoldingsIcon from '~/assets/icons/tuning/subcategories/roof_moldings.svg';
import roofSpoilerIcon from '~/assets/icons/tuning/subcategories/roof_spoiler.svg';
import seatsIcon from '~/assets/icons/tuning/subcategories/seats.svg';
import skirtsIcon from '~/assets/icons/tuning/subcategories/skirts.svg';
import skirtsTrimIcon from '~/assets/icons/tuning/subcategories/skirts_trim.svg';
import splitterIcon from '~/assets/icons/tuning/subcategories/splitter.svg';
import steeringWheelIcon from '~/assets/icons/tuning/subcategories/steering_wheel.svg';
import sunroofIcon from '~/assets/icons/tuning/subcategories/sunroof.svg';
import { VehicleTuningCategory, VehicleTuningSubcategory } from '~/shared';

export interface VehicleTuningShopCategoryConfig {
	id: VehicleTuningCategory;
	name: string;
}

export const VEHICLE_TUNING_CATEGORY_LABELS: Record<
	VehicleTuningCategory,
	string
> = {
	[VehicleTuningCategory.FRONT_BUMPER]: 'Передний бампер',
	[VehicleTuningCategory.REAR_BUMPER]: 'Задний бампер',
	[VehicleTuningCategory.DOORS]: 'Двери',
	[VehicleTuningCategory.BONNET]: 'Капот',
	[VehicleTuningCategory.BOOT]: 'Багажник',
	[VehicleTuningCategory.SKIRTS]: 'Пороги',
	[VehicleTuningCategory.ROOF]: 'Крыша',
	[VehicleTuningCategory.FENDERS]: 'Фендеры',
	[VehicleTuningCategory.LIGHTS]: 'Оптика',
	[VehicleTuningCategory.EXHAUST]: 'Выхлоп',
	[VehicleTuningCategory.INTERIOR]: 'Салон',
	[VehicleTuningCategory.CHASSIS]: 'Кузов',
	[VehicleTuningCategory.ENGINE]: 'Двигатель',
	[VehicleTuningCategory.RIMS]: 'Диски',
	[VehicleTuningCategory.KITS]: 'Наборы',
	[VehicleTuningCategory.WHEEL_SETTINGS]: 'Настройка колес',
};

const VEHICLE_TUNING_CATEGORY_ORDER: VehicleTuningCategory[] = [
	VehicleTuningCategory.FRONT_BUMPER,
	VehicleTuningCategory.REAR_BUMPER,
	VehicleTuningCategory.DOORS,
	VehicleTuningCategory.BONNET,
	VehicleTuningCategory.BOOT,
	VehicleTuningCategory.SKIRTS,
	VehicleTuningCategory.ROOF,
	VehicleTuningCategory.FENDERS,
	VehicleTuningCategory.LIGHTS,
	VehicleTuningCategory.EXHAUST,
	VehicleTuningCategory.INTERIOR,
	VehicleTuningCategory.CHASSIS,
	VehicleTuningCategory.ENGINE,
	VehicleTuningCategory.RIMS,
	VehicleTuningCategory.KITS,
	VehicleTuningCategory.WHEEL_SETTINGS,
];

export const VEHICLE_TUNING_SHOP_CATEGORIES = VEHICLE_TUNING_CATEGORY_ORDER.map(
	(id) => ({
		id,
		name: VEHICLE_TUNING_CATEGORY_LABELS[id],
	}),
);

export enum TuningGroup {
	FRONT_BUMPER = 'front_bumper',
	REAR_BUMPER = 'rear_bumper',
	DOORS = 'doors',
	BONNET = 'bonnet',
	BOOT = 'boot',
	SKIRTS = 'skirts',
	ROOF = 'roof',
	FENDERS = 'fenders',
	LIGHTS = 'lights',
	EXHAUST = 'exhaust',
	INTERIOR = 'interior',
	CHASSIS = 'chassis',
	ENGINE = 'engine',
}

export const TUNING_GROUP_CATEGORY: Record<TuningGroup, VehicleTuningCategory> =
	{
		[TuningGroup.FRONT_BUMPER]: VehicleTuningCategory.FRONT_BUMPER,
		[TuningGroup.REAR_BUMPER]: VehicleTuningCategory.REAR_BUMPER,
		[TuningGroup.DOORS]: VehicleTuningCategory.DOORS,
		[TuningGroup.BONNET]: VehicleTuningCategory.BONNET,
		[TuningGroup.BOOT]: VehicleTuningCategory.BOOT,
		[TuningGroup.SKIRTS]: VehicleTuningCategory.SKIRTS,
		[TuningGroup.ROOF]: VehicleTuningCategory.ROOF,
		[TuningGroup.FENDERS]: VehicleTuningCategory.FENDERS,
		[TuningGroup.LIGHTS]: VehicleTuningCategory.LIGHTS,
		[TuningGroup.EXHAUST]: VehicleTuningCategory.EXHAUST,
		[TuningGroup.INTERIOR]: VehicleTuningCategory.INTERIOR,
		[TuningGroup.CHASSIS]: VehicleTuningCategory.CHASSIS,
		[TuningGroup.ENGINE]: VehicleTuningCategory.ENGINE,
	};

export const TUNING_GROUP_ICONS: Record<TuningGroup, string> = {
	[TuningGroup.FRONT_BUMPER]: frontBumperGroup,
	[TuningGroup.REAR_BUMPER]: rearBumperGroup,
	[TuningGroup.DOORS]: doorsGroup,
	[TuningGroup.BONNET]: bonnetGroup,
	[TuningGroup.BOOT]: bootGroup,
	[TuningGroup.SKIRTS]: skirtsGroup,
	[TuningGroup.ROOF]: roofGroup,
	[TuningGroup.FENDERS]: fendersGroup,
	[TuningGroup.LIGHTS]: lightsGroup,
	[TuningGroup.EXHAUST]: exhaustGroup,
	[TuningGroup.INTERIOR]: interiorGroup,
	[TuningGroup.CHASSIS]: chassisGroup,
	[TuningGroup.ENGINE]: engineGroup,
};

export const TUNING_SUBCATEGORY_LABELS: Partial<
	Record<VehicleTuningSubcategory, string>
> = {
	[VehicleTuningSubcategory.FRONT_BUMPER]: 'Передний бампер',
	[VehicleTuningSubcategory.SPLITTER]: 'Сплиттер',
	[VehicleTuningSubcategory.GRILLE]: 'Решётка',
	[VehicleTuningSubcategory.FRONT_BUMPER_MISC]: 'Прочее',

	[VehicleTuningSubcategory.REAR_BUMPER]: 'Задний бампер',
	[VehicleTuningSubcategory.DIFFUSER]: 'Диффузор',
	[VehicleTuningSubcategory.EXHAUST]: 'Выхлоп',
	[VehicleTuningSubcategory.REAR_BUMPER_MISC]: 'Прочее',

	[VehicleTuningSubcategory.MIRRORS]: 'Зеркала',
	[VehicleTuningSubcategory.DOOR_MOLDINGS]: 'Дверные молдинги',
	[VehicleTuningSubcategory.DOOR_HANDLES]: 'Дверные ручки',
	[VehicleTuningSubcategory.DOOR_ATTACHMENTS]: 'Накладки дверей',
	[VehicleTuningSubcategory.DOOR_MISC]: 'Прочее',

	[VehicleTuningSubcategory.BONNET]: 'Капот',
	[VehicleTuningSubcategory.BONNET_MISC]: 'Прочее',

	[VehicleTuningSubcategory.BOOT]: 'Багажник',
	[VehicleTuningSubcategory.BOOT_SPOILER]: 'Спойлер',
	[VehicleTuningSubcategory.BOOT_LIGHTS]: 'Фонари',
	[VehicleTuningSubcategory.BOOT_MISC]: 'Прочее',

	[VehicleTuningSubcategory.SIDE_SKIRTS]: 'Пороги',
	[VehicleTuningSubcategory.SIDE_ATTACHMENTS]: 'Накладки',
	[VehicleTuningSubcategory.SIDE_SKIRTS_MISC]: 'Прочее',

	[VehicleTuningSubcategory.ROOF]: 'Крыша',
	[VehicleTuningSubcategory.ROOF_SPOILER]: 'Спойлер',
	[VehicleTuningSubcategory.SUNROOF]: 'Люк',
	[VehicleTuningSubcategory.ANTENNAS]: 'Антенны',
	[VehicleTuningSubcategory.ROOF_MOLDINGS]: 'Молдинги',
	[VehicleTuningSubcategory.ROOF_MISC]: 'Прочее',

	[VehicleTuningSubcategory.FRONT_FENDERS]: 'Передние крылья',
	[VehicleTuningSubcategory.REAR_FENDERS]: 'Задние крылья',

	[VehicleTuningSubcategory.FRONT_LIGHTS]: 'Передние фары',
	[VehicleTuningSubcategory.REAR_LIGHTS]: 'Задние фонари',

	[VehicleTuningSubcategory.INTERIOR]: 'Салон',
	[VehicleTuningSubcategory.SEATS]: 'Сиденья',
	[VehicleTuningSubcategory.STEERING_WHEEL]: 'Руль',
	[VehicleTuningSubcategory.INTERIOR_MISC]: 'Прочее',

	[VehicleTuningSubcategory.BODY_TRIMS]: 'Накладки',
	[VehicleTuningSubcategory.BODY_MISC]: 'Прочее',

	[VehicleTuningSubcategory.ENGINE]: 'Двигатель',
	[VehicleTuningSubcategory.ENGINE_TRIMS]: 'Накладки',
	[VehicleTuningSubcategory.ENGINE_MISC]: 'Прочее',
};

export const TUNING_SUBCATEGORY_ICONS: Partial<
	Record<VehicleTuningSubcategory, string>
> = {
	[VehicleTuningSubcategory.FRONT_BUMPER]: frontBumperIcon,
	[VehicleTuningSubcategory.SPLITTER]: splitterIcon,
	[VehicleTuningSubcategory.GRILLE]: grilleIcon,
	[VehicleTuningSubcategory.FRONT_BUMPER_MISC]: miscIcon,

	[VehicleTuningSubcategory.REAR_BUMPER]: rearBumperIcon,
	[VehicleTuningSubcategory.DIFFUSER]: diffuserIcon,
	[VehicleTuningSubcategory.EXHAUST]: exhaustIcon,
	[VehicleTuningSubcategory.REAR_BUMPER_MISC]: miscIcon,

	[VehicleTuningSubcategory.MIRRORS]: mirrorsIcon,
	[VehicleTuningSubcategory.DOOR_MOLDINGS]: doorMoldingsIcon,
	[VehicleTuningSubcategory.DOOR_HANDLES]: doorHandlesIcon,
	[VehicleTuningSubcategory.DOOR_ATTACHMENTS]: doorAttachIcon,
	[VehicleTuningSubcategory.DOOR_MISC]: miscIcon,

	[VehicleTuningSubcategory.BONNET]: bonnetIcon,
	[VehicleTuningSubcategory.BONNET_MISC]: miscIcon,

	[VehicleTuningSubcategory.BOOT]: bootIcon,
	[VehicleTuningSubcategory.BOOT_SPOILER]: bootSpoilerIcon,
	[VehicleTuningSubcategory.BOOT_LIGHTS]: bootLightsIcon,
	[VehicleTuningSubcategory.BOOT_MISC]: miscIcon,

	[VehicleTuningSubcategory.SIDE_SKIRTS]: skirtsIcon,
	[VehicleTuningSubcategory.SIDE_ATTACHMENTS]: skirtsTrimIcon,
	[VehicleTuningSubcategory.SIDE_SKIRTS_MISC]: miscIcon,

	[VehicleTuningSubcategory.ROOF]: roofIcon,
	[VehicleTuningSubcategory.ROOF_SPOILER]: roofSpoilerIcon,
	[VehicleTuningSubcategory.SUNROOF]: sunroofIcon,
	[VehicleTuningSubcategory.ANTENNAS]: antennaIcon,
	[VehicleTuningSubcategory.ROOF_MOLDINGS]: roofMoldingsIcon,
	[VehicleTuningSubcategory.ROOF_MISC]: miscIcon,

	[VehicleTuningSubcategory.FRONT_FENDERS]: frontFenderIcon,
	[VehicleTuningSubcategory.REAR_FENDERS]: rearFenderIcon,

	[VehicleTuningSubcategory.FRONT_LIGHTS]: frontLightsIcon,
	[VehicleTuningSubcategory.REAR_LIGHTS]: rearLightsIcon,

	[VehicleTuningSubcategory.INTERIOR]: interiorIcon,
	[VehicleTuningSubcategory.SEATS]: seatsIcon,
	[VehicleTuningSubcategory.STEERING_WHEEL]: steeringWheelIcon,
	[VehicleTuningSubcategory.INTERIOR_MISC]: miscIcon,

	[VehicleTuningSubcategory.BODY_TRIMS]: chassisTrimIcon,
	[VehicleTuningSubcategory.BODY_MISC]: miscIcon,

	[VehicleTuningSubcategory.ENGINE]: engineGroup,
	[VehicleTuningSubcategory.ENGINE_TRIMS]: chassisTrimIcon,
	[VehicleTuningSubcategory.ENGINE_MISC]: miscIcon,
};

export const TUNING_GROUP_SUBCATEGORIES: Record<
	TuningGroup,
	VehicleTuningSubcategory[]
> = {
	[TuningGroup.FRONT_BUMPER]: [
		VehicleTuningSubcategory.FRONT_BUMPER,
		VehicleTuningSubcategory.SPLITTER,
		VehicleTuningSubcategory.GRILLE,
		VehicleTuningSubcategory.FRONT_BUMPER_MISC,
	],
	[TuningGroup.REAR_BUMPER]: [
		VehicleTuningSubcategory.REAR_BUMPER,
		VehicleTuningSubcategory.DIFFUSER,
		VehicleTuningSubcategory.REAR_BUMPER_MISC,
	],
	[TuningGroup.DOORS]: [
		VehicleTuningSubcategory.MIRRORS,
		VehicleTuningSubcategory.DOOR_MOLDINGS,
		VehicleTuningSubcategory.DOOR_HANDLES,
		VehicleTuningSubcategory.DOOR_ATTACHMENTS,
		VehicleTuningSubcategory.DOOR_MISC,
	],
	[TuningGroup.BONNET]: [
		VehicleTuningSubcategory.BONNET,
		VehicleTuningSubcategory.BONNET_MISC,
	],
	[TuningGroup.BOOT]: [
		VehicleTuningSubcategory.BOOT,
		VehicleTuningSubcategory.BOOT_SPOILER,
		VehicleTuningSubcategory.BOOT_LIGHTS,
		VehicleTuningSubcategory.BOOT_MISC,
	],
	[TuningGroup.SKIRTS]: [
		VehicleTuningSubcategory.SIDE_SKIRTS,
		VehicleTuningSubcategory.SIDE_ATTACHMENTS,
		VehicleTuningSubcategory.SIDE_SKIRTS_MISC,
	],
	[TuningGroup.ROOF]: [
		VehicleTuningSubcategory.ROOF,
		VehicleTuningSubcategory.ROOF_SPOILER,
		VehicleTuningSubcategory.SUNROOF,
		VehicleTuningSubcategory.ANTENNAS,
		VehicleTuningSubcategory.ROOF_MOLDINGS,
		VehicleTuningSubcategory.ROOF_MISC,
	],
	[TuningGroup.FENDERS]: [
		VehicleTuningSubcategory.FRONT_FENDERS,
		VehicleTuningSubcategory.REAR_FENDERS,
	],
	[TuningGroup.LIGHTS]: [
		VehicleTuningSubcategory.FRONT_LIGHTS,
		VehicleTuningSubcategory.REAR_LIGHTS,
	],
	[TuningGroup.EXHAUST]: [VehicleTuningSubcategory.EXHAUST],
	[TuningGroup.INTERIOR]: [
		VehicleTuningSubcategory.INTERIOR,
		VehicleTuningSubcategory.SEATS,
		VehicleTuningSubcategory.STEERING_WHEEL,
		VehicleTuningSubcategory.INTERIOR_MISC,
	],
	[TuningGroup.CHASSIS]: [
		VehicleTuningSubcategory.BODY_TRIMS,
		VehicleTuningSubcategory.BODY_MISC,
	],
	[TuningGroup.ENGINE]: [
		VehicleTuningSubcategory.ENGINE,
		VehicleTuningSubcategory.ENGINE_TRIMS,
		VehicleTuningSubcategory.ENGINE_MISC,
	],
};

export const CATEGORY_TO_SUBCATEGORIES: Partial<
	Record<VehicleTuningCategory, VehicleTuningSubcategory[]>
> = {
	[VehicleTuningCategory.FRONT_BUMPER]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.FRONT_BUMPER],
	[VehicleTuningCategory.REAR_BUMPER]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.REAR_BUMPER],
	[VehicleTuningCategory.DOORS]: TUNING_GROUP_SUBCATEGORIES[TuningGroup.DOORS],
	[VehicleTuningCategory.BONNET]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.BONNET],
	[VehicleTuningCategory.BOOT]: TUNING_GROUP_SUBCATEGORIES[TuningGroup.BOOT],
	[VehicleTuningCategory.SKIRTS]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.SKIRTS],
	[VehicleTuningCategory.ROOF]: TUNING_GROUP_SUBCATEGORIES[TuningGroup.ROOF],
	[VehicleTuningCategory.FENDERS]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.FENDERS],
	[VehicleTuningCategory.LIGHTS]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.LIGHTS],
	[VehicleTuningCategory.EXHAUST]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.EXHAUST],
	[VehicleTuningCategory.INTERIOR]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.INTERIOR],
	[VehicleTuningCategory.CHASSIS]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.CHASSIS],
	[VehicleTuningCategory.ENGINE]:
		TUNING_GROUP_SUBCATEGORIES[TuningGroup.ENGINE],
};

export const SUBCATEGORY_TO_GROUP: Partial<
	Record<VehicleTuningSubcategory, TuningGroup>
> = (() => {
	const map: Partial<Record<VehicleTuningSubcategory, TuningGroup>> = {};
	(Object.keys(TUNING_GROUP_SUBCATEGORIES) as TuningGroup[]).forEach(
		(group) => {
			TUNING_GROUP_SUBCATEGORIES[group].forEach((subcategory) => {
				if (!map[subcategory]) {
					map[subcategory] = group;
				}
			});
		},
	);
	return map;
})();
